import { useMemo } from "react";
import type { ServiceOffering, ServiceRequest, ServiceWorkQueue } from "@/lib/service/types";
import { REQUEST_ORIGIN_LABELS } from "./serviceShared";

export function useFilteredServiceRequests(
  requests: ServiceRequest[],
  offerings: ServiceOffering[],
  queues: ServiceWorkQueue[],
  search: string,
  offeringFilter: string
): ServiceRequest[] {
  return useMemo(() => {
    let list = requests;
    if (offeringFilter) {
      list = list.filter((r) => r.offering_id === offeringFilter);
    }
    const q = search.trim().toLowerCase();
    if (!q) return list;

    const offeringById = new Map(offerings.map((o) => [o.id, o.label]));
    const queueById = new Map(queues.map((row) => [row.id, row.label]));

    return list.filter((r) => {
      const haystack = [
        r.location_label,
        r.location_address,
        r.description,
        r.preferred_timeframe,
        r.review_notes,
        REQUEST_ORIGIN_LABELS[r.origin] ?? r.origin,
        r.offering_id ? offeringById.get(r.offering_id) : "",
        r.queue_id ? queueById.get(r.queue_id) : "",
      ]
        .join(" ")
        .toLowerCase();
      return haystack.includes(q);
    });
  }, [requests, offerings, queues, search, offeringFilter]);
}
